import { createSlice } from '@reduxjs/toolkit';

// Actions
import { prebuildOrderSuccess } from '../actions/order';
import { actualizePackageSuccess } from '../actions/actualization';

// Types
import type { ServicesStateType } from '../services/types';

const initialState: ServicesStateType = [];

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(prebuildOrderSuccess, (_, action) => {
        const {
          package: { extras },
        } = action.payload;

        return extras;
      })
      .addCase(actualizePackageSuccess, (_, action) => {
        const {
          data: {
            package: { extras },
          },
        } = action.payload;

        return extras;
      });
  },
});

export default servicesSlice.reducer;
